import { useFlag } from '@unleash/proxy-client-react';
import { FeatureFlag } from 'constants/feature-flags';
import { ManualSignInInstructionProps } from './DefaultSignInManualInstruction';
import { IsolvedManualSignInInstructions } from './ISolved/IsolvedManualSignInInstructions';
import { isIsolvedNetworkProvider } from './ISolved/providers';

export const useManualSignInComponent = (
  payrollProviderId?: string,
): ((props: ManualSignInInstructionProps) => JSX.Element) | undefined => {
  const customIsolvedInstructionsEnabled = useFlag(
    FeatureFlag.ConnectCustomIsolvedManualInstructionsPage,
  );

  if (!payrollProviderId) return undefined;

  if (
    customIsolvedInstructionsEnabled &&
    isIsolvedNetworkProvider(payrollProviderId)
  ) {
    return IsolvedManualSignInInstructions;
  }

  return undefined;
};
